import React, { useState } from "react";

function AIAnalysisCard({ deviceData }) {
    const [collapsed, setCollapsed] = useState(false);

    const maintenanceCount =
        deviceData?.aggregateMaintenanceSchedule?._count?.id ?? 0;
    const jobScheduleCount = deviceData?.aggregateJobSchedule?._count?.id ?? 0;

    return (
        <div className="card card-outline" style={{ borderColor: "#7c3aed" }}>
            <div
                className="card-header"
                style={{
                    background:
                        "linear-gradient(135deg, #7c3aed 0%, #6366f1 100%)",
                    color: "#ffffff",
                    position: "relative",
                    overflow: "hidden",
                }}
            >
                <div style={{ position: "relative", zIndex: 1 }}>
                    <h3 className="card-title tw-font-bold">
                        <i
                            className="fas fa-sparkles mr-2"
                            style={{ color: "#ffffff" }}
                        ></i>
                        Manufacturing Insights
                        <span
                            className="badge badge-light badge-pill ml-2"
                            style={{
                                background: "rgba(255,255,255,0.9)",
                                color: "#7c3aed",
                                fontWeight: "bold",
                            }}
                        >
                            ✨ AI Powered Analysis
                        </span>
                    </h3>
                </div>
                {/* Sparkle decorations */}
                <i
                    className="fas fa-star"
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "100px",
                        color: "rgba(255,255,255,0.7)",
                        fontSize: "12px",
                        animation: "twinkle 2s infinite",
                    }}
                ></i>
                <i
                    className="fas fa-star"
                    style={{
                        position: "absolute",
                        bottom: "15px",
                        right: "150px",
                        color: "rgba(255,255,255,0.5)",
                        fontSize: "8px",
                        animation: "twinkle 3s infinite 0.5s",
                    }}
                ></i>
                <i
                    className="fas fa-sparkles"
                    style={{
                        position: "absolute",
                        top: "50%",
                        right: "200px",
                        color: "rgba(255,255,255,0.6)",
                        fontSize: "10px",
                        animation: "twinkle 2.5s infinite 1s",
                    }}
                ></i>
                <style>{`
                    @keyframes twinkle {
                        0%, 100% { opacity: 0.3; transform: scale(1); }
                        50% { opacity: 1; transform: scale(1.2); }
                    }
                `}</style>
                <div className="card-tools">
                    <button
                        type="button"
                        className="btn btn-tool"
                        style={{ color: "#ffffff" }}
                        onClick={() => setCollapsed(!collapsed)}
                    >
                        <i
                            className={`fas ${collapsed ? "fa-plus" : "fa-minus"}`}
                        ></i>
                    </button>
                </div>
            </div>
            <div
                className={`card-body ${collapsed ? "d-none" : ""}`}
                style={{
                    transition: "all 0.3s ease",
                    background:
                        "linear-gradient(180deg, rgba(124,58,237,0.05) 0%, rgba(99,102,241,0.03) 100%)",
                }}
            >
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <h6 className="text-bold mb-2">
                                <i className="fas fa-chart-line mr-2 text-success"></i>
                                Plant Efficiency Analysis
                            </h6>
                            <p className="text-sm text-muted mb-2">
                                Your current plant efficiency of{" "}
                                <strong className="text-danger">10%</strong> is
                                below the industry average. Based on historical
                                data, we've identified key improvement areas:
                            </p>
                            <ul className="text-sm ml-3">
                                <li className="mb-1">
                                    Device downtime is contributing{" "}
                                    <strong>6.2%</strong> to efficiency loss
                                </li>
                                <li className="mb-1">
                                    Unoptimized job schedules are causing{" "}
                                    <strong>2.8%</strong> inefficiency
                                </li>
                                <li className="mb-1">
                                    Maintenance gaps are reducing output by{" "}
                                    <strong>1%</strong>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3">
                            <h6 className="text-bold mb-2">
                                <i className="fas fa-cogs mr-2 text-warning"></i>
                                Maintenance & Schedule Impact
                            </h6>
                            <p className="text-sm text-muted mb-2">
                                AI analysis shows that optimizing your{" "}
                                <a href="/maintenance" className="text-info">
                                    {maintenanceCount} maintenance schedules
                                </a>{" "}
                                and{" "}
                                <a href="/job-schedules" className="text-info">
                                    {jobScheduleCount} job schedules
                                </a>{" "}
                                could boost efficiency by up to{" "}
                                <strong className="text-success">15-20%</strong>
                                .
                            </p>
                            <div className="alert alert-light border p-2 mb-0">
                                <small className="d-block mb-1">
                                    <i className="fas fa-lightbulb text-warning mr-1"></i>
                                    <strong>Recommendation:</strong>
                                </small>
                                <small className="text-muted">
                                    Schedule preventive maintenance during
                                    low-demand periods and align job schedules
                                    with{" "}
                                    <a href="/devices" className="text-info">
                                        high-performing devices
                                    </a>{" "}
                                    to maximize throughput.
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AIAnalysisCard;
